<app-loading *ngIf="carInformacionInicial"></app-loading>
<div *ngIf="!carInformacionInicial">
  <div class="grid" *ngIf="!esDetalle">
    <div class="col-12 md:col-6 lg:col-6">
      <!-- BUSCADOR DATATABLE PARAMETROS -->
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <input
            #gb
            type="text"
            pInputText
            size="40"
            placeholder="{{ 'LBL_BUSCAR' | translate }}"
            (input)="dt.filterGlobal($event.target.value, 'contains')"
          />
        </div>
      </div>

      <!-- DATATABLE PARAMETROS -->
      <div class="grid">
        <div class="col-12 md:col-12 lg:col-12">
          <p-table
            [columns]="columnas"
            #dt
            [value]="lisParametros"
            selectionMode="single"
            dataKey="idParametros"
            [paginator]="true"
            [rows]="10"

            paginatorPosition="bottom"
          >
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th
                  *ngFor="let col of columns"
                  [pSortableColumn]="col.field"
                  [pSortableColumnDisabled]="!col.sort"
                  class="text-center"
                >
                  {{ col.header }}
                  <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                </th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-row>
              <tr [pSelectableRow]="row">
                <td>{{ row.codigoParametro }}</td>
                <td>{{ row.parametro }}</td>
                <td class="text-center">
                  <div class="btn-group" role="group">
                    <button
                      type="button"
                      class="p-button p-button-success btn"
                      icon="fa fa-arrow-right"
                      data-toggle="tooltip"
                      title="{{ 'BTN_AGREGAR' | translate }}"
                      pButton
                      (click)="abrirModalVinculaciones(row.codigoParametro)"
                    ></button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="columns.length" class="text-center">
                  {{ "MSG_NOHAYREGISTROS" | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>
      </div>
    </div>

    <!-- FORMULARIO PLANTEAMIENTO DE POLITICA -->
    <div class="col-12 md:col-6 lg:col-6">
      <form [formGroup]="formulario" (ngSubmit)="onSubmit()" novalidate>
        <!-- VARIABLE 1 -->
        <div class="grid form-group">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <label for="variable1"
              >* {{ "POLITICAS.LBL_VARIABLE1" | translate }}</label
              >
              <textarea
                id="variable1"
                name="variable1"
                pInputTextarea
                rows="6"
                style="width: 100%"
                autocomplete="off"
                formControlName="variable1"
                maxlength="500"
                required
                (focus)="focusCampo('variable1')"
                appTexto
                [parametros]="true"
                [sinComa]="false"
              ></textarea>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.variable1.invalid"
              >
                {{ "POLITICAS.LBL_VARIABLE1" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
          </div>
        </div>

        <!-- OPERACION -->
        <div class="grid form-group">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <label>* {{ "POLITICAS.LBL_OPERACION" | translate }}</label>
              <p-dropdown disableTab
                id="idOperacion"
                [options]="listaCondiciones"
                formControlName="idOperacion"
                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                optionValue="value"
                optionLabel="label"
              ></p-dropdown>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.idOperacion.invalid"
              >
                {{ "POLITICAS.LBL_OPERACION" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
          </div>
        </div>

        <!-- VARIABLE 2 -->
        <div class="grid form-group">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <label for="variable2"
              >* {{ "POLITICAS.LBL_VARIABLE2" | translate }}</label
              >
              <textarea
                id="variable2"
                name="variable2"
                pInputTextarea
                rows="6"
                style="width: 100%"
                autocomplete="off"
                formControlName="variable2"
                maxlength="500"
                required
                (focus)="focusCampo('variable2')"
                appTexto
                [parametros]="true"
                [sinComa]="false"
              ></textarea>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.variable2.invalid"
              >
                {{ "POLITICAS.LBL_VARIABLE2" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
          </div>
        </div>

        <!-- CODICIONAL -->
        <div class="grid form-group">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="div-form">
              <label>* {{ "POLITICAS.LBL_CONDICIONAL" | translate }}</label>
              <p-dropdown disableTab
                id="idCondicional"
                [options]="listaTiposCondicionales"
                formControlName="idCondicional"
                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                optionValue="value"
                optionLabel="label"
              ></p-dropdown>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="submitted && f.idCondicional.invalid"
              >
                {{ "POLITICAS.LBL_CONDICIONAL" | translate }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- BOTON AGREGAR  PoliticaPlanteamientoPolitica -->
  <div class="grid" *ngIf="!esDetalle">
    <div class="col-12">
      <label>{{'POLITICAS.LBL_REORDENAR' | translate}}</label>
    </div>
    <div class="col-12" style="text-align: left;display: flex;align-items: center;">
      <label style="margin: 0 5px;">{{'LBL_NO' | translate}}</label>
      <p-inputSwitch (onChange)="actualizarOrden($event.checked)"></p-inputSwitch>
      <label style="margin: 0 5px;">{{'LBL_SI' | translate}}</label>
    </div>
    <div class="col-12 md:col-6 lg:col-6" style="text-align: right">
      <button
        icon="fa fa-plus"
        label="{{ 'BTN_AGREGAR' | translate }}"
        type="button"
        pButton
        (click)="onSubmit()"
      ></button>
    </div>
  </div>
  <!-- DATATABLE PoliticaPlanteamientoPolitica -->
  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12">
      <p-table
        *ngIf="!carTabla"
        [columns]="columnas2"
        #dt
        [value]="centralizadaPoliticas.politicasPlanteamientosPoliticas"
        selectionMode="single"
        dataKey="idPoliticaPlanteamientoPolitica"
        [paginator]="true"
        [rows]="10"

        paginatorPosition="bottom"
        [loading]="carTabla"
      >
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th
              *ngFor="let col of columns"
              [pSortableColumn]="col.field"
              [pSortableColumnDisabled]="!col.sort"
              class="text-center"
            >
              {{ col.header }}
              <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
            </th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-row let-index="rowIndex">
          <tr [pSelectableRow]="row">
            <td *ngIf="!ordenar" class="text-center">{{ row.orden }}</td>
            <td *ngIf="ordenar" class="text-center">
              <div class="btn-group text-center" role="group">
                <button type="button" class="p-button p-button-info btn btnDown" icon="fa fa-arrow-down"
                        data-toggle="tooltip"
                        title="{{'BTN_ABAJO' | translate}}"
                        *ngIf="index >=0 && index<centralizadaPoliticas.politicasPlanteamientosPoliticas.length-1"
                        pButton (click)="cambiarOrden(row, false)"></button>
                <button type="button" class="p-button p-button-info btn btnUp" icon="fa fa-arrow-up"
                        data-toggle="tooltip"
                        title="{{'BTN_ARRIBA' | translate}}" pButton *ngIf="index >0"
                        (click)="cambiarOrden(row, true)"
                ></button>
              </div>
            </td>
            <td>{{ row.variable1 }}</td>
            <td>{{ row.operacion }}</td>
            <td>{{ row.variable2 }}</td>
            <td>{{ row.tipoCondicional }}</td>
            <td class="text-center">
              <div class="btn-group" role="group">
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-trash"
                  data-toggle="tooltip"
                  title="{{ 'BTN_ELIMINAR' | translate }}"
                  pButton
                  [disabled]="esDetalle"
                  (click)="eliminarPoliticaPlanteamientoPolitica(row, index)"
                ></button>
                <button
                  type="button"
                  class="p-button p-button-success btn"
                  icon="fa fa-pencil"
                  data-toggle="tooltip"
                  title="{{ 'BTN_EDITAR' | translate }}"
                  pButton
                  [disabled]="esDetalle"
                  (click)="editarPoliticaPlanteamientoPolitica(row)"
                ></button>
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage" let-columns>
          <tr>
            <td [attr.colspan]="columns.length" class="text-center">
              {{ "MSG_NOHAYREGISTROS" | translate }}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>

  <!-- BOTON COMPROBAR POLITICA -->
  <div class="grid" *ngIf="!esDetalle">
    <div class="col-12 md:col-12 lg:col-12" style="text-align: right">
      <button
        icon="fa fa-check-square"
        label="{{ 'POLITICAS.LBL_COMPROBARPOLITICA' | translate }}"
        type="button"
        pButton
        [disabled]="
          centralizadaPoliticas &&
          centralizadaPoliticas.politicasPlanteamientosPoliticas
            ? centralizadaPoliticas.politicasPlanteamientosPoliticas.length <= 0
            : true
        "
        (click)="abrirModalComprobarPolitica()"
      ></button>
    </div>
    <div class="col-12 md:col-12 lg:col-12" *ngIf="cantidadPatron.length > 1">
      <label>{{'POLITICAS.LBL_ORDENEJECUCION' | translate}}</label>
      <input type="text" pInputText [(ngModel)]="centralizadaPoliticas.politica.ordenEjecucion" disabled>
    </div>
  </div>
</div>

<!-- MODAL VINCULACIONES -->
<p-dialog
  [draggable]="false"
  [resizable]="false"
  [closable]="false"

  [(visible)]="mostrarDialogoVinculaciones"
  header="{{ 'POLITICAS.LBL_SELECCIONARVINCULACION' | translate }}"
  [modal]="true"
  *ngIf="mostrarDialogoVinculaciones && !esDetalle"
  class="overflow-y-unset"
>
  <div>
    <!-- VINCULACION -->
    <label
    >* {{ "POLITICAS.LBL_SELECCIONARVINCULACIONAGREGAR" | translate }}</label
    >
    <form [formGroup]="formularioVinculaciones" (ngSubmit)="null" novalidate>
      <div class="grid form-group">
        <div class="col-12 md:col-12 lg:col-12">
          <div class="div-form">
            <p-multiSelect
              id="codigosVinculaciones"
              name="nomVinculaciones"
              [options]="listaTiposVinculaciones"
              defaultLabel="{{ 'LBL_SELECCIONE' | translate }}"
              selectedItemsLabel="{0} {{
                'LBL_ELEMENTOSSELECCIONADOS' | translate
              }}"
              formControlName="codigosVinculaciones"
              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
              optionValue="value"
              optionLabel="label"
            ></p-multiSelect>
            <div
              class="p-message p-messages-error p-corner-all"
              *ngIf="submittedModalVinculaciones && fCoontrolsVinculaciones.codigosVinculaciones.invalid"
            >
              {{ "LBL_REQUERIDO" | translate }}
            </div>
          </div>
        </div>
      </div>
    </form>

    <div class="grid form-footer-buttons">
      <div class="form-group col-12">
        <a (click)="cerrarModalVinculaciones()" class="cancelar">{{
          "BTN_CANCELAR" | translate
          }}</a>
        <button
          icon="fa fa-plus"
          label="{{ 'BTN_AGREGAR' | translate }}"
          type="submit"
          (click)="agregarParametro()"
          pButton
        ></button>
      </div>
    </div>
  </div>
</p-dialog>

<!-- MODAL COMPROBAR POLITICAS -->
<p-dialog
  header="{{ 'POLITICAS.LBL_PRUEBAPOLITICA' | translate }}"
  [(visible)]="mostrarDialogoComprobarPolitica"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"

  modal="true"
  [contentStyle]="banVentaCruzada ? { width: '970px' } : { width: '800px' }"
  *ngIf="mostrarDialogoComprobarPolitica && !esDetalle"
  class="overflow-y-unset"
>
  <div class="text-center">
    <label>{{
      "POLITICAS.LBL_INGRESARINFORMACIONPRUEBAPOLITICA" | translate
      }}</label>
  </div>

  <!-- FORMULARIO COMPROBAR POLITICA -->
  <div
    class="grid form-group"
    [ngClass]="{ 'ventacruzada': banVentaCruzada && ( inputsCreditosAntiguos.length > 3 || inputsCreditosNuevos.length > 3) }"
    *ngIf="lisParametrosAgregados && !carFormularioComprobarPolitica"
  >
    <div class="col-12 md:col-12 lg:col-12">
      <form
        [formGroup]="formularioComprobarPolitica"
        (ngSubmit)="comprobarPolitica()"
        novalidate
      >
        <div class="grid form-group">
          <ng-container *ngFor="let parametro of lisParametrosAgregados">
          <div
            class="col-12 md:col-6 lg:col-6"
          [ngClass]="{
            'col-12 md:col-6 lg:col-6': !banVentaCruzada,
            'col-12 md:col-12 lg:col-12': banVentaCruzada
          }"
            *ngIf="parametro.codigoParametro !== parametrosPoliticas.SALARIO"
          >
             <div class="div-form">
              <label for="producto" *ngIf="parametro.codigoParametro !== parametrosPoliticas.MES &&
                                          parametro.codigoParametro !== parametrosPoliticas.ANIO &&
                                          parametro.codigoParametro !== parametrosPoliticas.SALARIO &&
                                          parametro.codigoParametro !== parametrosPoliticas.PORCENTAJESALDOCANCELADO &&
                                          parametro.codigoParametro !== parametrosPoliticas.MESESCUOTASPAGADAS &&
                                          parametro.codigoParametro !== parametrosPoliticas.EDADTERCERO &&
                                          parametro.codigoParametro !== parametrosPoliticas.CAMBIODEVINCULACION &&
                                          parametro.codigoParametro !== parametrosPoliticas.VINVULACIONRESPALDOS &&
                                          parametro.codigoParametro !== parametrosPoliticas.PORCENTAJECOBERTURA &&
                                          parametro.codigoParametro !== parametrosPoliticas.NIVELRIESGOEMPLEADOR &&
                                          parametro.codigoParametro !== parametrosPoliticas.DIA &&
                                          parametro.codigoParametro !== parametrosPoliticas.CONTINUIDADLABORAL &&
                                          parametro.codigoParametro !== parametrosPoliticas.ULTOCU &&
                                          parametro.codigoParametro !== parametrosPoliticas.ULTACTECO &&
                                          parametro.codigoParametro !== parametrosPoliticas.GARIDON &&
                                          parametro.codigoParametro !== parametrosPoliticas.CONNOM &&
                                          parametro.codigoParametro !== parametrosPoliticas.ENDINTSOC"
              >* {{ parametro.parametro | titlecase }}</label>
              <input
                *ngIf="parametro.codigoParametro === parametrosPoliticas.MONSOL ||
                       parametro.codigoParametro === parametrosPoliticas.VAPRIC ||
                       parametro.codigoParametro === parametrosPoliticas.VACUMA ||
                       parametro.codigoParametro === parametrosPoliticas.MONAGR"
                type="text"
                pInputText
                id="id{{ parametro.codigoParametro }}"
                name="nom{{ parametro.codigoParametro }}"
                autocomplete="off"
                formControlName="{{ parametro.codigoParametro }}"
                appTexto
                moneda-reactive
                [sinCaracteres]="false"
                [sinComa]="true"
                [sinEspacio]="true" [sinPunto]="true"
                [sinLetras]="true"
                [maxlength]="17"
              />
              <input
                *ngIf="parametro.codigoParametro === parametrosPoliticas.MONSOLPRE"
                type="text"
                pInputText
                id="id{{ parametro.codigoParametro }}"
                name="nom{{ parametro.codigoParametro }}"
                autocomplete="off"
                formControlName="{{ parametro.codigoParametro }}"
                appTexto
                moneda-reactive
                [sinCaracteres]="parametro.codigoParametro !== parametrosPoliticas.MONSOLPRE"
                [sinComa]="true"
                [sinEspacio]="true" [sinPunto]="true"
                [sinLetras]="parametro.codigoParametro === parametrosPoliticas.MONSOLPRE"
                [maxlength]="parametro.codigoParametro === parametrosPoliticas.MONSOLPRE ? 17 : maxLength"
              />
              <label class="label-desembolso" *ngIf="parametro.codigoParametro === parametrosPoliticas.OBLIGACIONESVIGENTES">{{ 'POLITICAS.LBL_CANTIDADCREDITOCREZCAMOS' | translate }}</label>
              <input
                *ngIf="
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADCOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADSECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.PLAZOMES ||
                  parametro.codigoParametro === parametrosPoliticas.VIGENTEFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.VIGENTECOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.VIGENTESECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.CERRADASFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.CERRADASCOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.CERRADASSECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.RESTVIGENTEFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.RESTVIGENTECOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.RESTVIGENTEREAL ||
                  parametro.codigoParametro === parametrosPoliticas.MORAFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.MORACOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.MORAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.MORATELECOMUNICACIONES ||
                  parametro.codigoParametro === parametrosPoliticas.CASTIGADAFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.CASTIGADACOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.CASTIGADAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.ROTACIONCAPITALTRABAJO ||
                  parametro.codigoParametro === parametrosPoliticas.CUENTAAHORROEMBARGADA ||
                  parametro.codigoParametro === parametrosPoliticas.CUENTACORRIENTEEMBARGADA ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIVIGENTESFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.VEOBVISEFI3 ||
                  parametro.codigoParametro === parametrosPoliticas.VEOBVISECO3 ||
                  parametro.codigoParametro === parametrosPoliticas.VEOBVISERE3 ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIVIGENTESCOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.VALORINGRESOPENSIONADO ||
                  parametro.codigoParametro === parametrosPoliticas.VALORINGRESOEMPLEADO ||
                  parametro.codigoParametro === parametrosPoliticas.VALORINGRESOINDEPENDIENTE ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIVIGENTEREAL ||
                  parametro.codigoParametro === parametrosPoliticas.RESTRUCTURADAFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.REESTRUCTURADACOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.REESTRUCTURADAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.UNIDADPRODUCTIVA ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIG ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIGSECFIN ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIGSECCOO ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIGSECREL ||
                  parametro.codigoParametro === parametrosPoliticas.ANAULTPAGOCOBJURIDICO ||
                  parametro.codigoParametro === parametrosPoliticas.ANAULTPAGOCOBJURIDICOSECFIN ||
                  parametro.codigoParametro === parametrosPoliticas.ANAULTPAGOCOBJURIDICOSECCOO ||
                  parametro.codigoParametro === parametrosPoliticas.ANAULTPAGOCOBJURIDICOSECREL ||
                  parametro.codigoParametro === parametrosPoliticas.MESESPOSESIONUNIDADPRODUCTIVA ||
                  parametro.codigoParametro === parametrosPoliticas.MESESUBICACIONACTUALUNIDADPRODUCTIVA ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADTARJETASCREDITO ||
                  parametro.codigoParametro === parametrosPoliticas.CICLOSPRODUCTIVOSUP ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIGACIONESVIGENTESTELCOS ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIGACIONESVIGENTESTELCOSDOS ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIGACIONESRESTRUCTURADASTELCOS ||
                  parametro.codigoParametro === parametrosPoliticas.MORAVIGENTESECTORFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.MORAVIGENTESECTORCOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.MORAVIGENTESECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.MORAVIGENTESECTORTELCOS ||
                  parametro.codigoParametro === parametrosPoliticas.CASTIGADATELCOS ||
                  parametro.codigoParametro === parametrosPoliticas.NOTAINTERNA ||
                  parametro.codigoParametro === parametrosPoliticas.NUMEROBLIGACIONES ||
                  parametro.codigoParametro === parametrosPoliticas.TSCORE ||
                  parametro.codigoParametro === parametrosPoliticas.HUELLASCONSULTA ||
                  parametro.codigoParametro === parametrosPoliticas.HUELLASCONSULTA2 ||
                  parametro.codigoParametro === parametrosPoliticas.HUELLASCONSULTA3 ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADESHUELLASNOIDENTIFICADAS ||
                  parametro.codigoParametro === parametrosPoliticas.SALDOMORAESPECIALIZADOREAL ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADESCARTERACASTESPECIALIZADAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIGACIONRESTVIGESCPECIALIZADAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.RESTVIGESCPECIALIZADAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.NUMEROENTIDADESSECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIGACIONVIGESPECIALIZADAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIGACIONVIGESPECIALIZADAREAL2 ||
                  parametro.codigoParametro === parametrosPoliticas.VEOBVISEREESP3 ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIGACIONCERESPECIALIZADAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.DIASMORAPASINT ||
                  parametro.codigoParametro === parametrosPoliticas.DIASMORAPASINTIT ||
                  parametro.codigoParametro === parametrosPoliticas.DIASMORAPASINTCOD ||
                  parametro.codigoParametro === parametrosPoliticas.DIASMORAPASINTDS ||
                  parametro.codigoParametro === parametrosPoliticas.TOTALLIQUIDEZCUBIERTA ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIGACIONESVIGENTES ||
                  parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO1 ||
                  parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO2 ||
                  parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO3 ||
                  parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO4 ||
                  parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO5 ||
                  parametro.codigoParametro === parametrosPoliticas.TIPOESTADOCIVIL ||
                  parametro.codigoParametro === parametrosPoliticas.ENTSECFINPM ||
                  parametro.codigoParametro === parametrosPoliticas.ENTSECCOOPPM ||
                  parametro.codigoParametro === parametrosPoliticas.ENTSECREALPM ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADTARJETASCREDITOPASIVOMANUAL ||
                  parametro.codigoParametro === parametrosPoliticas.CORREOTERCERO ||
                  parametro.codigoParametro === parametrosPoliticas.TIPOCONTRATO ||
                  parametro.codigoParametro === parametrosPoliticas.ANTIGUEDADMESES ||
                  parametro.codigoParametro === parametrosPoliticas.PAGADURIA ||
                  parametro.codigoParametro === parametrosPoliticas.TIPOSECTOR ||
                  parametro.codigoParametro === parametrosPoliticas.SALDORECOGERSECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.NUMEROEMPLEADOS ||
                  parametro.codigoParametro === parametrosPoliticas.FECHACONSTITUCION ||
                  parametro.codigoParametro === parametrosPoliticas.NATURALEZATERC ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADEMPLEADOS ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADPENSIONADOS ||
                  parametro.codigoParametro === parametrosPoliticas.OCUPAC ||
                  parametro.codigoParametro === parametrosPoliticas.ESTADODOCUMENTO ||
                  parametro.codigoParametro === parametrosPoliticas.CANPASREES ||
                  parametro.codigoParametro === parametrosPoliticas.CAMABE ||
                  parametro.codigoParametro === parametrosPoliticas.CLIBEN
                "
                type="text"
                pInputText
                id="id{{ parametro.codigoParametro }}"
                name="nom{{ parametro.codigoParametro }}"
                autocomplete="off"
                formControlName="{{ parametro.codigoParametro }}"
                appTexto
                (keyup)="limitarNumero($event.target, parametro.codigoParametro)"
                [pattern]="
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADEMPLEADOS ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADPENSIONADOS ||
                  parametro.codigoParametro === parametrosPoliticas.CLIBEN ? '^[0-1]$' : null
                "
                [sinCaracteres]="
                  parametro.codigoParametro === parametrosPoliticas.MORAFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.MORACOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.MORAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.MORATELECOMUNICACIONES ||
                  parametro.codigoParametro === parametrosPoliticas.CASTIGADAFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.CASTIGADACOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.CASTIGADAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.ROTACIONCAPITALTRABAJO ||
                  parametro.codigoParametro === parametrosPoliticas.CUENTAAHORROEMBARGADA ||
                  parametro.codigoParametro === parametrosPoliticas.CUENTACORRIENTEEMBARGADA ||
                  parametro.codigoParametro === parametrosPoliticas.RESTVIGENTEFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.RESTVIGENTECOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.VALORINGRESOPENSIONADO ||
                  parametro.codigoParametro === parametrosPoliticas.VALORINGRESOEMPLEADO ||
                  parametro.codigoParametro === parametrosPoliticas.VALORINGRESOINDEPENDIENTE ||
                  parametro.codigoParametro === parametrosPoliticas.RESTVIGENTEREAL ||
                  parametro.codigoParametro === parametrosPoliticas.UNIDADPRODUCTIVA ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIG ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIGSECFIN ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIGSECCOO ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIGSECREL ||
                  parametro.codigoParametro === parametrosPoliticas.MESESPOSESIONUNIDADPRODUCTIVA ||
                  parametro.codigoParametro === parametrosPoliticas.MESESUBICACIONACTUALUNIDADPRODUCTIVA ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADTARJETASCREDITO ||
                  parametro.codigoParametro === parametrosPoliticas.CICLOSPRODUCTIVOSUP ||
                  parametro.codigoParametro === parametrosPoliticas.MORAVIGENTESECTORFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.MORAVIGENTESECTORCOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.MORAVIGENTESECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.MORAVIGENTESECTORTELCOS ||
                  parametro.codigoParametro === parametrosPoliticas.CASTIGADATELCOS ||
                  parametro.codigoParametro === parametrosPoliticas.NOTAINTERNA ||
                  parametro.codigoParametro === parametrosPoliticas.NUMEROBLIGACIONES ||
                  parametro.codigoParametro === parametrosPoliticas.TSCORE ||
                  parametro.codigoParametro === parametrosPoliticas.HUELLASCONSULTA ||
                  parametro.codigoParametro === parametrosPoliticas.HUELLASCONSULTA2 ||
                  parametro.codigoParametro === parametrosPoliticas.HUELLASCONSULTA3 ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADESHUELLASNOIDENTIFICADAS ||
                  parametro.codigoParametro === parametrosPoliticas.SALDOMORAESPECIALIZADOREAL ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADESCARTERACASTESPECIALIZADAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIGACIONRESTVIGESCPECIALIZADAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.NUMEROENTIDADESSECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.DIASMORAPASINT ||
                  parametro.codigoParametro === parametrosPoliticas.DIASMORAPASINTIT ||
                  parametro.codigoParametro === parametrosPoliticas.DIASMORAPASINTCOD ||
                  parametro.codigoParametro === parametrosPoliticas.DIASMORAPASINTDS ||
                  parametro.codigoParametro === parametrosPoliticas.TOTALLIQUIDEZCUBIERTA ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIGACIONESVIGENTES ||
                  parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO1 ||
                  parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO2 ||
                  parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO3 ||
                  parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO4 ||
                  parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO5 ||
                  parametro.codigoParametro === parametrosPoliticas.TIPOESTADOCIVIL ||
                  parametro.codigoParametro === parametrosPoliticas.ENTSECFINPM ||
                  parametro.codigoParametro === parametrosPoliticas.ENTSECCOOPPM ||
                  parametro.codigoParametro === parametrosPoliticas.ENTSECREALPM ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADTARJETASCREDITOPASIVOMANUAL ||
                  parametro.codigoParametro === parametrosPoliticas.CORREOTERCERO ||
                  parametro.codigoParametro === parametrosPoliticas.TIPOCONTRATO ||
                  parametro.codigoParametro === parametrosPoliticas.ANTIGUEDADMESES ||
                  parametro.codigoParametro === parametrosPoliticas.PAGADURIA ||
                  parametro.codigoParametro === parametrosPoliticas.TIPOSECTOR ||
                  parametro.codigoParametro === parametrosPoliticas.SALDORECOGERSECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADEMPLEADOS ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADPENSIONADOS ||
                  parametro.codigoParametro === parametrosPoliticas.OCUPAC ||
                  parametro.codigoParametro === parametrosPoliticas.ESTADODOCUMENTO ||
                  parametro.codigoParametro === parametrosPoliticas.CANPASREES ||
                  parametro.codigoParametro === parametrosPoliticas.CAMABE ||
                  parametro.codigoParametro === parametrosPoliticas.CLIBEN
                "
                [sinComa]="true"
                [sinEspacio]="true" [sinPunto]="true"
                [sinLetras]="
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADCOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADSECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.PLAZOMES ||
                  parametro.codigoParametro === parametrosPoliticas.MORAFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.MORACOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.MORAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.MORATELECOMUNICACIONES ||
                  parametro.codigoParametro === parametrosPoliticas.CASTIGADAFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.CASTIGADACOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.CASTIGADAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.ROTACIONCAPITALTRABAJO ||
                  parametro.codigoParametro === parametrosPoliticas.CUENTAAHORROEMBARGADA ||
                  parametro.codigoParametro === parametrosPoliticas.CUENTACORRIENTEEMBARGADA ||
                  parametro.codigoParametro === parametrosPoliticas.RESTVIGENTEFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.RESTVIGENTECOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.RESTVIGENTEREAL ||
                  parametro.codigoParametro === parametrosPoliticas.VALORINGRESOPENSIONADO ||
                  parametro.codigoParametro === parametrosPoliticas.VALORINGRESOEMPLEADO ||
                  parametro.codigoParametro === parametrosPoliticas.VALORINGRESOINDEPENDIENTE ||
                  parametro.codigoParametro === parametrosPoliticas.UNIDADPRODUCTIVA ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIG ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIGSECFIN ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIGSECCOO ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIGSECREL ||
                  parametro.codigoParametro === parametrosPoliticas.MESESPOSESIONUNIDADPRODUCTIVA ||
                  parametro.codigoParametro === parametrosPoliticas.MESESUBICACIONACTUALUNIDADPRODUCTIVA ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADTARJETASCREDITO ||
                  parametro.codigoParametro === parametrosPoliticas.CICLOSPRODUCTIVOSUP ||
                  parametro.codigoParametro === parametrosPoliticas.MORAVIGENTESECTORFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.MORAVIGENTESECTORCOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.MORAVIGENTESECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.MORAVIGENTESECTORTELCOS ||
                  parametro.codigoParametro === parametrosPoliticas.CASTIGADATELCOS ||
                  parametro.codigoParametro === parametrosPoliticas.NOTAINTERNA ||
                  parametro.codigoParametro === parametrosPoliticas.NUMEROBLIGACIONES ||
                  parametro.codigoParametro === parametrosPoliticas.TSCORE ||
                  parametro.codigoParametro === parametrosPoliticas.HUELLASCONSULTA ||
                  parametro.codigoParametro === parametrosPoliticas.HUELLASCONSULTA2 ||
                  parametro.codigoParametro === parametrosPoliticas.HUELLASCONSULTA3 ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADESHUELLASNOIDENTIFICADAS ||
                  parametro.codigoParametro === parametrosPoliticas.SALDOMORAESPECIALIZADOREAL ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADESCARTERACASTESPECIALIZADAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIGACIONRESTVIGESCPECIALIZADAREAL ||
                  parametro.codigoParametro === parametrosPoliticas.NUMEROENTIDADESSECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.DIASMORAPASINT ||
                  parametro.codigoParametro === parametrosPoliticas.DIASMORAPASINTIT ||
                  parametro.codigoParametro === parametrosPoliticas.DIASMORAPASINTCOD ||
                  parametro.codigoParametro === parametrosPoliticas.DIASMORAPASINTDS ||
                  parametro.codigoParametro === parametrosPoliticas.TOTALLIQUIDEZCUBIERTA ||
                  parametro.codigoParametro === parametrosPoliticas.OBLIGACIONESVIGENTES ||
                  parametro.codigoParametro === parametrosPoliticas.ENTSECFINPM ||
                  parametro.codigoParametro === parametrosPoliticas.ENTSECCOOPPM ||
                  parametro.codigoParametro === parametrosPoliticas.ENTSECREALPM ||
                  parametro.codigoParametro === parametrosPoliticas.CANTIDADTARJETASCREDITOPASIVOMANUAL ||
                  parametro.codigoParametro === parametrosPoliticas.CORREOTERCERO ||
                  parametro.codigoParametro === parametrosPoliticas.TIPOCONTRATO ||
                  parametro.codigoParametro === parametrosPoliticas.ANTIGUEDADMESES ||
                  parametro.codigoParametro === parametrosPoliticas.PAGADURIA ||
                  parametro.codigoParametro === parametrosPoliticas.TIPOSECTOR ||
                  parametro.codigoParametro === parametrosPoliticas.SALDORECOGERSECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.NUMEROEMPLEADOS ||
                  parametro.codigoParametro === parametrosPoliticas.FECHACONSTITUCION ||
                  parametro.codigoParametro === parametrosPoliticas.NATURALEZATERC  ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADEMPLEADOS ||
                  parametro.codigoParametro === parametrosPoliticas.ENTIDADPENSIONADOS ||
                  parametro.codigoParametro === parametrosPoliticas.OCUPAC ||
                  parametro.codigoParametro === parametrosPoliticas.CANPASREES ||
                  parametro.codigoParametro === parametrosPoliticas.CAMABE ||
                  parametro.codigoParametro === parametrosPoliticas.CLIBEN
                 "
                [maxlength]="parametro.codigoParametro === parametrosPoliticas.OCUPAC ? 9 :
                             parametro.codigoParametro === parametrosPoliticas.VALORINGRESOPENSIONADO ||
                             parametro.codigoParametro === parametrosPoliticas.VALORINGRESOEMPLEADO ||
                             parametro.codigoParametro === parametrosPoliticas.VALORINGRESOINDEPENDIENTE ||
                             parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIG ||
                             parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIGSECFIN ||
                             parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIGSECCOO ||
                             parametro.codigoParametro === parametrosPoliticas.CANTIDADCRECOBJURVIGSECREL ||
                             parametro.codigoParametro === parametrosPoliticas.MESESPOSESIONUNIDADPRODUCTIVA ||
                             parametro.codigoParametro === parametrosPoliticas.MESESUBICACIONACTUALUNIDADPRODUCTIVA ||
                             parametro.codigoParametro === parametrosPoliticas.CANTIDADTARJETASCREDITO ||
                             parametro.codigoParametro === parametrosPoliticas.CICLOSPRODUCTIVOSUP ||
                             parametro.codigoParametro === parametrosPoliticas.CASTIGADATELCOS ||
                             parametro.codigoParametro === parametrosPoliticas.TSCORE ||
                             parametro.codigoParametro === parametrosPoliticas.TOTALLIQUIDEZCUBIERTA ||
                             parametro.codigoParametro === parametrosPoliticas.NUMEROBLIGACIONES ||
                             parametro.codigoParametro === parametrosPoliticas.OBLIGACIONESVIGENTES ||
                             parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO1 ||
                             parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO2 ||
                             parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO3 ||
                             parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO4 ||
                             parametro.codigoParametro === parametrosPoliticas.ACTIVIDADECONOMICAGRUPO5 ||
                             parametro.codigoParametro === parametrosPoliticas.TIPOESTADOCIVIL ||
                             parametro.codigoParametro === parametrosPoliticas.CANTIDADTARJETASCREDITOPASIVOMANUAL ? 3 :
                             parametro.codigoParametro === parametrosPoliticas.NOTAINTERNA ||
                             parametro.codigoParametro === parametrosPoliticas.PAGADURIA ||
                             parametro.codigoParametro === parametrosPoliticas.CORREOTERCERO ||
                             parametro.codigoParametro === parametrosPoliticas.NATURALEZATERC ||
                              parametro.codigoParametro === parametrosPoliticas.ENTIDADEMPLEADOS ||
                              parametro.codigoParametro === parametrosPoliticas.ENTIDADPENSIONADOS ||
                              parametro.codigoParametro === parametrosPoliticas.CLIBEN ? 1 :
                              parametro.codigoParametro === parametrosPoliticas.ANTIGUEDADMESES ||
                              parametro.codigoParametro === parametrosPoliticas.CANPASREES ||
                              parametro.codigoParametro === parametrosPoliticas.FECHACONSTITUCION ||
                              parametro.codigoParametro === parametrosPoliticas.CAMABE ? 3 :
                             parametro.codigoParametro === parametrosPoliticas.SALDORECOGERSECTORREAL ||
                             parametro.codigoParametro === parametrosPoliticas.ESTADODOCUMENTO? 12 :
                             parametro.codigoParametro === parametrosPoliticas.NUMEROEMPLEADOS ? 5 :
                              (parametro.codigoParametro === ( parametrosPoliticas.DIASMORAPASINT || parametrosPoliticas.DIASMORAPASINTIT || parametrosPoliticas.DIASMORAPASINTCOD  || parametrosPoliticas.DIASMORAPASINTDS )) ? 4 : 18
                            "
              />
               <label class="falso-combo-texto" style="margin-top: 1rem; display: block;"
                      *ngIf="parametro.codigoParametro === parametrosPoliticas.PATRITECN">
                 {{ (constantePattec?.indicadorHabilitado && Number(constantePattec?.valor) > 0 ? Number(constantePattec?.valor)
                 : 0) | dinero }}
               </label>
               <p-dropdown disableTab  id="id{{ parametro.codigoParametro }}" name="nom{{ parametro.codigoParametro }}"
                          *ngIf="
                              parametro.codigoParametro === parametrosPoliticas.OCUPACIONPENSIONADO ||
                              parametro.codigoParametro === parametrosPoliticas.OCUPACIONEMPLEADO
                          "
                          [options]="listaAdmOcupaciones"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                           formControlName="{{parametro.codigoParametro}}"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
              ></p-dropdown>
              <p-dropdown disableTab  id="id{{ parametro.codigoParametro }}" name="nom{{ parametro.codigoParametro }}"
                          *ngIf="parametro.codigoParametro === parametrosPoliticas.TIPODOCUMENTOVERIFICAR"
                          [options]="listaTiposDocumentos"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                           formControlName="{{parametro.codigoParametro}}"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
              ></p-dropdown>
              <p-dropdown disableTab  id="id{{ parametro.codigoParametro }}" name="nom{{ parametro.codigoParametro }}"
                          *ngIf="
                              parametro.codigoParametro === parametrosPoliticas.ECONOMICACOMERCIO ||
                              parametro.codigoParametro === parametrosPoliticas.ECONOMICASERVICIO ||
                              parametro.codigoParametro === parametrosPoliticas.ACTIVIDADAGROPECUARIA ||
                              parametro.codigoParametro === parametrosPoliticas.CULTIVOSMEDIANORENDIMIENTO ||
                              parametro.codigoParametro === parametrosPoliticas.CULTIVOSTARDIORENDIMIENTO ||
                              parametro.codigoParametro === parametrosPoliticas.CULTIVOSTRANSITORIOS ||
                              parametro.codigoParametro === parametrosPoliticas.ACTIVIDADESPECUARIAS ||
                              parametro.codigoParametro === parametrosPoliticas.ACTIVIDADPRODUCCION
                          "
                          [options]="listActividadEconomica"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                           formControlName="{{parametro.codigoParametro}}"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
              ></p-dropdown>
              <p-dropdown disableTab  id="id{{ parametro.codigoParametro }}" name="nom{{ parametro.codigoParametro }}"
                          *ngIf="parametro.codigoParametro === parametrosPoliticas.VALORFRECUENCIA"
                          [options]="listaFrecuenciaProductoCodigo"
                          placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                           formControlName="{{parametro.codigoParametro}}"
                          emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                          optionValue="value"
                          optionLabel="label"
              ></p-dropdown>
              <!-- Destruccion Familiar -  validacion conyuge -->
              <div *ngIf="parametro.codigoParametro === parametrosPoliticas.VALIDACIONFIRMASCONYUGES">
                <div style="margin-top: 10px;">
                  <label for="saldoCapital" style="font-size:14px !important">{{ "POLITICAS.LBL_ESTADOCIVILINICIAL" | translate }}</label>
                  <p-dropdown disableTab  id="{{ parametro.codigoParametro + '1'}}" name="nom{{ parametro.codigoParametro }}"
                              [options]="listaEstadosCiviles"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                               formControlName="estadoInicial"
                              (onChange)="calcularFirmas(parametro.codigoParametro)"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submittedModalComprobarPolitica && !fCoontrolsFCP['estadoInicial'].value">
                    {{ "LBL_VALORREQUERIDO" | translate }}
                  </div>
                </div>
                <div style="margin-top: 10px;">
                  <label for="saldoCapital" style="font-size:14px !important">{{ "POLITICAS.LBL_ESTADOCIVILFINAL" | translate }}</label>
                  <p-dropdown disableTab  id="{{ parametro.codigoParametro + '1'}}" name="nom{{ parametro.codigoParametro }}"
                              [options]="listaEstadosCiviles"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                               formControlName="estadoFinal"
                              (onChange)="calcularFirmas(parametro.codigoParametro)"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submittedModalComprobarPolitica && !fCoontrolsFCP['estadoFinal'].value">
                    {{ "LBL_VALORREQUERIDO" | translate }}
                  </div>
                </div>
                <div class="grid" style="margin-top: 10px; flex-wrap: nowrap;">
                  <div class="col-12"><p-radioButton (click)="calcularFirmas(parametro.codigoParametro)" name="conyuge" [value]="estadoConyuge.NOAPLICA" label="{{ 'POLITICAS.LBL_NOAPLICA' | translate}}" formControlName="conyuge"></p-radioButton></div>
                  <div class="col-12"><p-radioButton (click)="calcularFirmas(parametro.codigoParametro)" name="conyuge" [value]="estadoConyuge.DIFERENTE" label="{{ 'POLITICAS.LBL_DIFERENTE' | translate}}" formControlName="conyuge"></p-radioButton></div>
                  <div class="col-12"><p-radioButton (click)="calcularFirmas(parametro.codigoParametro)" name="conyuge" [value]="estadoConyuge.IGUAL" label="{{ 'POLITICAS.LBL_IGUAL' | translate}}" formControlName="conyuge"></p-radioButton></div>
                </div>
                <div style="margin-top: 10px;" *ngIf="formularioComprobarPolitica.get('conyuge')?.value !== estadoConyuge.NOAPLICA">
                  <label for="saldoCapital" style="font-size:14px !important">{{ "POLITICAS.LBL_ESTADOCONYUGETERCERO" | translate }}</label>
                  <p-dropdown disableTab  id="{{ parametro.codigoParametro + '2' }}" name="nom{{ parametro.codigoParametro }}"
                              [options]="listaEstadosUnidadFamiliar"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                               formControlName="estadoConyuge"
                              (onChange)="calcularFirmas(parametro.codigoParametro)"
                              emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                              optionValue="value"
                              optionLabel="label"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="submittedModalComprobarPolitica && !fCoontrolsFCP['estadoConyuge'].value">
                    {{ "LBL_VALORREQUERIDO" | translate }}
                  </div>
                </div>
              </div>
              <!-- Venta cruzada -->
               <div class="container-venta-cruzada" *ngIf="parametro.codigoParametro === parametrosPoliticas.VENTACRUZADA">
                  <div style="flex: 1;">
                    <label class="vanta-cruzada-label">{{ 'POLITICAS.LBL_CREDITOANTIGUOS' | translate }}</label>
                    <div *ngFor="let input of inputsCreditosAntiguos; let i = index">
                      <div class="p-grid venta-cruzada-group">
                        <p-dropdown disableTab  class="p-col-5" id="{{ parametro.codigoParametro + '2' }}" name="nom{{ parametro.codigoParametro }}"
                                [options]="(i === 0) ? listaTiposVinculacionesCruzada : listaTiposVinculacionesCruzadaSinTitular"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                                [autoWidth]="false"
                                formControlName="{{'tipoVinculacion' + i}}"
                                (onChange)="validarVentaCruzadaVinculacion($event, inputsCreditosAntiguos, parametro.codigoParametro, i)"
                                [disabled]="i === 0"
                        ></p-dropdown>
                        <input  type="text" class="p-col-5"
                                pInputText
                                id="{{ parametro.codigoParametro + i}}" name="nom{{ parametro.codigoParametro }}"
                                placeholder="{{ 'POLITICAS.LBL_NUMERODECEDULA' | translate }}"
                                autocomplete="off"
                                (keypress)="onKeyPress($event)"
                                (input)="onInputChange($event, inputsCreditosAntiguos, i)"
                                (blur)="validarVentaCruzada($event, inputsCreditosAntiguos, parametro.codigoParametro, i)"
                                />
                        <div class="venta-cruzada-button">
                          <button *ngIf="i === 0" class="p-col-2"
                                  pButton
                                  type="button"
                                  (click)="addInputCreditosAntiguos()"
                                  class="add-button"
                                  icon="fa fa-plus"
                                  ></button>
                          <button *ngIf="i !== 0" class="p-col-2"
                                  pButton
                                  type="button"
                                  (click)="removeInput(i, 'inputsCreditosAntiguos', parametro.codigoParametro)"
                                  class="remove-button"
                                  icon="fa fa-minus"
                                  ></button>
                        </div>
                      </div>
                      <div  class="p-message p-messages-error p-corner-all"
                            *ngIf="submittedModalComprobarPolitica && errorIndicesAntiguos.includes(i)">
                            {{ 'LBL_CAMPO' | translate }}
                            {{ "LBL_REQUERIDO" | translate }}
                      </div>
                    </div>
                  </div>
                  <div style="flex: 1;">
                    <label class="vanta-cruzada-label">{{ 'POLITICAS.LBL_SOLICITUDACTUAL' | translate }}</label>
                    <div *ngFor="let input of inputsCreditosNuevos; let i = index">
                      <div class="p-grid venta-cruzada-group">
                        <p-dropdown disableTab  class="p-col-5" id="{{ parametro.codigoParametro + '2' }}" name="nom{{ parametro.codigoParametro }}"
                                [options]="(i === 0) ? listaTiposVinculacionesCruzada : listaTiposVinculacionesCruzadaSinTitular"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                                [autoWidth]="false"
                                formControlName="{{'tipoVinculacionNuevo' + i}}"
                                (onChange)="validarVentaCruzadaVinculacion($event, inputsCreditosNuevos, parametro.codigoParametro, i)"
                                [disabled]="i === 0"
                        ></p-dropdown>
                        <input  type="text" class="p-col-5"
                                pInputText
                                id="{{ parametro.codigoParametro + i}}" name="nom{{ parametro.codigoParametro }}"
                                placeholder="{{ 'POLITICAS.LBL_NUMERODECEDULA' | translate }}"
                                autocomplete="off"
                                (keypress)="onKeyPress($event)"
                                (input)="onInputChange($event, inputsCreditosNuevos, i)"
                                (blur)="validarVentaCruzada($event, inputsCreditosNuevos, parametro.codigoParametro, i)"
                                />
                        <div class="venta-cruzada-button">
                          <button *ngIf="i === 0" class="p-col-2"
                                  pButton
                                  type="button"
                                  (click)="addInputCreditosNuevos()"
                                  class="add-button"
                                  icon="fa fa-plus"
                                  ></button>
                          <button *ngIf="i !== 0" class="p-col-2"
                                  pButton
                                  type="button"
                                  (click)="removeInput(i, 'inputsCreditosNuevos', parametro.codigoParametro)"
                                  class="remove-button"
                                  icon="fa fa-minus"
                                  ></button>
                        </div>
                      </div>
                      <div  class="p-message p-messages-error p-corner-all"
                            *ngIf="submittedModalComprobarPolitica && errorIndicesNuevos.includes(i)">
                            {{ 'LBL_CAMPO' | translate }}
                            {{ "LBL_REQUERIDO" | translate }}
                      </div>
                    </div>
                  </div>
               </div>
               <!-- Meses desembolsado -->
               <div *ngIf="parametro.codigoParametro === parametrosPoliticas.MESESDESEMBOLSO">
                <label class="label-desembolso">{{ 'POLITICAS.LBL_FECHAULTIMODESEMBOLSO' | translate }}</label>
                <p-calendar
                  id="id{{ parametro.codigoParametro + 'calendar' }}"
                  [showButtonBar]="false"
                  name="nom{{ parametro.codigoParametro + 'calendar' }}"
                  [showIcon]="true"
                  [showTime]="false"
                  [monthNavigator]="true"
                  [yearNavigator]="true"
                  yearRange="{{ calPropiedades.rango }}"
                  [locale]="calPropiedades.informacion"
                  [maxDate]="fechaDeHoy"
                  readonlyInput="true"
                  dataType="date"
                  dateFormat="yy'-'mm'-'dd"
                  (onSelect)="onDateSelect($event, parametro.codigoParametro)"
                >
                </p-calendar>
                <div  class="p-message p-messages-error p-corner-all"
                      *ngIf="submittedModalComprobarPolitica && fCoontrolsFCP[parametro.codigoParametro].invalid">
                      {{ 'LBL_CAMPO' | translate }}
                      {{ "LBL_REQUERIDO" | translate }}
                </div>
                <label class="label-desembolso">{{ 'POLITICAS.LBL_FECHAACTUAL' | translate }}</label>
                <label class="falso-combo-texto">{{ fechaDeHoyFormatted }}</label>
                <label class="label-desembolso">{{ 'POLITICAS.LBL_MESESDESEMBOLSO' | translate }}</label>
                <label class="falso-combo-texto">{{ diferenciaMeses }}</label>
              </div>
              <!--Input para parametros que requieren decimales-->
              <input
                *ngIf="parametro.codigoParametro === parametrosPoliticas.ANTIGUEDADMESESCREZCAMOS ||
                        parametro.codigoParametro === parametrosPoliticas.INDENDEUDAMIENTONEGOCIO ||
                        parametro.codigoParametro === parametrosPoliticas.CANTIDADDEUDORES ||
                        parametro.codigoParametro === parametrosPoliticas.CANTIDADCODEUDORES"
                type="text"
                pInputText
                id="id{{ parametro.codigoParametro }}"
                name="nom{{ parametro.codigoParametro }}"
                autocomplete="off"
                formControlName="{{ parametro.codigoParametro }}"
                appTexto
                numero-decimal-reactive
                [sinComa]="true"
                [sinEspacio]="true"
                [decimales]=" parametro.codigoParametro === parametrosPoliticas.ANTIGUEDADMESESCREZCAMOS ? 2 :
                              parametro.codigoParametro === parametrosPoliticas.INDENDEUDAMIENTONEGOCIO ? 6 : 0"
                [entero]="parametro.codigoParametro === parametrosPoliticas.CANTIDADDEUDORES ||
                          parametro.codigoParametro === parametrosPoliticas.CANTIDADCODEUDORES ? 2 :
                          parametro.codigoParametro === parametrosPoliticas.ANTIGUEDADMESESCREZCAMOS ||
                          parametro.codigoParametro === parametrosPoliticas.INDENDEUDAMIENTONEGOCIO ? 3 : 0"
                [sinCaracteres]="parametro.codigoParametro === parametrosPoliticas.ANTIGUEDADMESESCREZCAMOS ||
                                 parametro.codigoParametro === parametrosPoliticas.INDENDEUDAMIENTONEGOCIO"
                [sinPunto]="false"
                [sinLetras]="parametro.codigoParametro === parametrosPoliticas.ANTIGUEDADMESESCREZCAMOS ||
                             parametro.codigoParametro === parametrosPoliticas.INDENDEUDAMIENTONEGOCIO"
                style="text-align: right"
              >
              <input type="text" pInputText id="id{{ parametro.codigoParametro }}"
                     name="nom{{parametro.codigoParametro}}"
                     [negativo]="parametro.codigoParametro === parametrosPoliticas.FLUJOCAJABRUTO ||
                                 parametro.codigoParametro === parametrosPoliticas.LIQUIDEZTOTALDISPONIBLE ||
                                 parametro.codigoParametro === parametrosPoliticas.OBLIFINANCIERACUOTADEUDASNEG ? true : false"
                     autocomplete="new-password"
                     [minimo]="parametro.codigoParametro === parametrosPoliticas.FLUJOCAJABRUTO ||
                               parametro.codigoParametro === parametrosPoliticas.LIQUIDEZTOTALDISPONIBLE ||
                               parametro.codigoParametro === parametrosPoliticas.OBLIFINANCIERACUOTADEUDASNEG ? -999999999 : 0"
                     moneda-reactive
                     *ngIf="
                          parametro.codigoParametro === parametrosPoliticas.VALORPRODUCTOSVENTASCOMPRAS ||
                          parametro.codigoParametro === parametrosPoliticas.TOTALPATRIMONIO ||
                          parametro.codigoParametro === parametrosPoliticas.ENDEUDAMIENTODATACREDITO ||
                          parametro.codigoParametro === parametrosPoliticas.CAPITALTRABAJO ||
                          parametro.codigoParametro === parametrosPoliticas.SALDOTELEFONIA ||
                          parametro.codigoParametro === parametrosPoliticas.MONTOSUGERIDO ||
                          parametro.codigoParametro === parametrosPoliticas.FLUJOCAJABRUTO ||
                          parametro.codigoParametro === parametrosPoliticas.LIQUIDEZTOTALDISPONIBLE ||
                          parametro.codigoParametro === parametrosPoliticas.OBLIFINANCIERACUOTADEUDASNEG ||
                          parametro.codigoParametro === parametrosPoliticas.VALORVENTASNEGOCIO ||
                          parametro.codigoParametro === parametrosPoliticas.VALORDECOSTOSNEGOCIO ||
                          parametro.codigoParametro === parametrosPoliticas.GASTOSFAMILIARES ||
                          parametro.codigoParametro === parametrosPoliticas.OTROSINGRESOS ||
                          parametro.codigoParametro === parametrosPoliticas.TOTALVENTAS ||
                          parametro.codigoParametro === parametrosPoliticas.CUOTAMONTOSUGERIDO ||
                          parametro.codigoParametro === parametrosPoliticas.ENDDATACREDITOCOMPLETO ||
                          parametro.codigoParametro === parametrosPoliticas.ENDDATACREDITOVIVIENDA ||
                          parametro.codigoParametro === parametrosPoliticas.ENDCREZCAMOS ||
                          parametro.codigoParametro === parametrosPoliticas.ENDCREZCAMOSREES ||
                          parametro.codigoParametro === parametrosPoliticas.VALORCUOTA ||
                          parametro.codigoParametro === parametrosPoliticas.VALORMONTO ||
                          parametro.codigoParametro === parametrosPoliticas.VALORDEINVENTARIOS ||
                          parametro.codigoParametro === parametrosPoliticas.VALORACTIVOSFIJOSNEGOCIOMUEBLES ||
                          parametro.codigoParametro === parametrosPoliticas.VALORACTIVOSFIJOSNEGOCIOVEHICULOS ||
                          parametro.codigoParametro === parametrosPoliticas.VALORACTIVOSFIJOSNEGOCIOINMUEBLES ||
                          parametro.codigoParametro === parametrosPoliticas.VALORTOTALPASIVOS ||
                          parametro.codigoParametro === parametrosPoliticas.VALORTOTALINGRESOSHOGAR ||
                          parametro.codigoParametro === parametrosPoliticas.VALORLIQUIDEZNEGOCIO ||
                          parametro.codigoParametro === parametrosPoliticas.VALORLIQUIDEZCUBIERTALIBRANZA ||
                          parametro.codigoParametro === parametrosPoliticas.CAPACIDADPAGODISPONIBLELIBRANZA ||
                          parametro.codigoParametro === parametrosPoliticas.NUEVACUOTALIBRANZA ||
                          parametro.codigoParametro === parametrosPoliticas.REMANENTECAPACIDADPAGOLIBRANZA ||
                          parametro.codigoParametro === parametrosPoliticas.MONTOULTIMODESEMBOLSOVIGENTECREZCAMOS ||
                          parametro.codigoParametro === parametrosPoliticas.MONTOULTIMODESEMBOLSOSALDADOCREZCAMOS ||
                          parametro.codigoParametro === parametrosPoliticas.GARANTIASPRENDARIASMUEBLESENSERESHOGAR ||
                          parametro.codigoParametro === parametrosPoliticas.GARANTIASPRENDARIASMUEBLESENSERESMAQUINARIA ||
                          parametro.codigoParametro === parametrosPoliticas.GARANTIASPRENDARIASVEHICULOSHOGAR ||
                          parametro.codigoParametro === parametrosPoliticas.GARANTIASPRENDARIASVEHICULOSNEGOCIO ||
                          parametro.codigoParametro === parametrosPoliticas.SALDOHIPOTECARIOBURO ||
                          parametro.codigoParametro === parametrosPoliticas.VALORTOTALPRENDARIAS ||
                          parametro.codigoParametro === parametrosPoliticas.INCREMENTOMONTO ||
                          parametro.codigoParametro === parametrosPoliticas.OTROSRESPALDOSPREDIO ||
                          parametro.codigoParametro === parametrosPoliticas.OTROSRESPALDOSSALARIO ||
                          parametro.codigoParametro === parametrosPoliticas.OTROSRESPALDOSTRANSPORTE ||
                          parametro.codigoParametro === parametrosPoliticas.OTROSRESPALDOSFUENTESPAGOS ||
                          parametro.codigoParametro === parametrosPoliticas.OTROSRESPALDOSNEGOCIO ||
                          parametro.codigoParametro === parametrosPoliticas.OTROSRESPALDOSHIPOTECA ||
                          parametro.codigoParametro === parametrosPoliticas.COBERTURAFONDO ||
                          parametro.codigoParametro === parametrosPoliticas.ENDEUDAMIENTOINTERNO ||
                          parametro.codigoParametro === parametrosPoliticas.PASIVOSCRZCOMERCIAL ||
                          parametro.codigoParametro === parametrosPoliticas.PASIVOSRECOGERCRZCOMERCIAL ||
                          parametro.codigoParametro === parametrosPoliticas.ENDEUDAMIENTOEXTERNO ||
                          parametro.codigoParametro === parametrosPoliticas.TOTALDEUDASNEGOCIO ||
                          parametro.codigoParametro === parametrosPoliticas.SALDOPASIVOSREGOGERTITULAR ||
                          parametro.codigoParametro === parametrosPoliticas.SALDOPASIVORECOGERCODEUSOR ||
                          parametro.codigoParametro === parametrosPoliticas.SALDOPASRECOGERDEUSO ||
                          parametro.codigoParametro === parametrosPoliticas.TOTALACTIVOS ||
                          parametro.codigoParametro === parametrosPoliticas.TOTALPASIVOS ||
                          parametro.codigoParametro === parametrosPoliticas.TOTALOTROSRESPALDOS ||
                          parametro.codigoParametro === parametrosPoliticas.PREDIONOLEGALIZADO ||
                          parametro.codigoParametro === parametrosPoliticas.CONTROLESTADOBURO ||
                          parametro.codigoParametro === parametrosPoliticas.ENDEUDAMIENTODATACREDITOPASIVOMANUAL ||
                          parametro.codigoParametro === parametrosPoliticas.SALDOTELEFONIAPASIVOMANUAL ||
                          parametro.codigoParametro === parametrosPoliticas.ENDEUDAMIENTODATACREDITOCOMPLETOPM ||
                          parametro.codigoParametro === parametrosPoliticas.ENDEUDAMIENTODATACREDITOVIVIENDAPM ||
                          parametro.codigoParametro === parametrosPoliticas.DESPRENDIBLEPAGO ||
                          parametro.codigoParametro === parametrosPoliticas.INGRESOSMENSUALES ||
                          parametro.codigoParametro === parametrosPoliticas.DEDUCCIONES
                      "
                     (input)="actualizarMaxLength(parametro.codigoParametro)"
                     formControlName="{{parametro.codigoParametro}}"
                     [maxlength]="parametro.codigoParametro === parametrosPoliticas.SALDOTELEFONIA ||
                     parametro.codigoParametro === parametrosPoliticas.MONTOSUGERIDO  ? 13 :
                     parametro.codigoParametro === parametrosPoliticas.INGRESOSMENSUALES  ? 12 :
                     (parametro.codigoParametro === parametrosPoliticas.FLUJOCAJABRUTO ||
                      parametro.codigoParametro === parametrosPoliticas.GASTOSFAMILIARES ||
                      parametro.codigoParametro === parametrosPoliticas.OTROSINGRESOS ||
                      parametro.codigoParametro === parametrosPoliticas.TOTALVENTAS ||
                      parametro.codigoParametro === parametrosPoliticas.CUOTAMONTOSUGERIDO ||
                      parametro.codigoParametro === parametrosPoliticas.ENDDATACREDITOCOMPLETO ||
                      parametro.codigoParametro === parametrosPoliticas.ENDDATACREDITOVIVIENDA ||
                      parametro.codigoParametro === parametrosPoliticas.ENDCREZCAMOS ||
                      parametro.codigoParametro === parametrosPoliticas.ENDCREZCAMOSREES ||
                      parametro.codigoParametro === parametrosPoliticas.LIQUIDEZTOTALDISPONIBLE ||
                      parametro.codigoParametro === parametrosPoliticas.SALDOTELEFONIAPASIVOMANUAL ? maxLength : 18)"
                     style="text-align: right"
              />
              <input *ngIf="parametro.codigoParametro === parametrosPoliticas.PUNTAJESCOREDESEMPLEO"
                      pInputText type="text"
                      min="-999"
                      max="999"
                      step="1"
                      formControlName="{{parametro.codigoParametro}}"
                      (input)="limitarRango(parametro.codigoParametro)"
                      style="text-align: right;"
               />
              <div style="margin-top: 1rem;"  *ngIf="parametro.codigoParametro === parametrosPoliticas.PORCENTAJESALDOCANCELADO ||
                                                     parametro.codigoParametro === parametrosPoliticas.MESESCUOTASPAGADAS ||
                                                     parametro.codigoParametro === parametrosPoliticas.EDADTERCERO ||
                                                     parametro.codigoParametro === parametrosPoliticas.CAMBIODEVINCULACION ||
                                                     parametro.codigoParametro === parametrosPoliticas.VINVULACIONRESPALDOS ||
                                                     parametro.codigoParametro === parametrosPoliticas.PORCENTAJECOBERTURA ||
                                                     parametro.codigoParametro === parametrosPoliticas.NIVELRIESGOEMPLEADOR ||
                                                     parametro.codigoParametro === parametrosPoliticas.ULTOCU ||
                                                     parametro.codigoParametro === parametrosPoliticas.ULTACTECO ||
                                                     parametro.codigoParametro === parametrosPoliticas.GARIDON ||
                                                     parametro.codigoParametro === parametrosPoliticas.CONTINUIDADLABORAL ||
                                                     parametro.codigoParametro === parametrosPoliticas.ENDINTSOC" >
                <p-fieldset legend="* {{ parametro.parametro | titlecase }}">

                  <!-- Continuidad Laboral -->
                  <div *ngIf="parametro.codigoParametro === parametrosPoliticas.CONTINUIDADLABORAL">
                    <label for="ocupacion" style="font-size:14px !important">{{ "POLITICAS.LBL_OCUPACION" | translate }}</label>
                    <p-dropdown disableTab  id="idOcupacion" name="nomOcupacion"
                                [options]="listTipoOcupaciones"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                                formControlName="ocupacion"
                                class="continuidadLaboral"
                                (onChange)="calcularContinuidadLaboral(parametro.codigoParametro)"
                    ></p-dropdown>
                    <label for="valorNivel" style="font-size:14px !important">{{ "POLITICAS.LBL_VECTOR" | translate}}</label>
                    <input
                      type="text"
                      pInputText
                      id="idVector"
                      name="nomVector"
                      autocomplete="off"
                      formControlName="vector"
                      [maxlength]="36"
                      (input)="calcularContinuidadLaboral(parametro.codigoParametro)"
                      style="text-align: right; margin-bottom: 1rem; border-bottom: 1px solid #bdbdbd"
                    />
                  </div>

                  <!-- Última Ocupación (ULTOCU) -->
                  <div *ngIf="parametro.codigoParametro === parametrosPoliticas.ULTOCU">
                    <label for="ocupacionAnterior" style="font-size:14px !important">{{ 'POLITICAS.LBL_OCUPACIONANTERIOR' | translate }}</label>
                    <p-dropdown disableTab id="idOcupacionAnterior" name="nomOcupacionAnterior"
                                [options]="listTipoOcupaciones"
                                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                                optionValue="value"
                                optionLabel="label"
                                formControlName="ocupacionAnterior"
                                (onChange)="calcularUltimaOcupacion(parametro.codigoParametro)"
                    ></p-dropdown>
                    <label for="ocupacionActual" style="font-size:14px !important; margin-top: 10px; display: block;">
                      {{ 'POLITICAS.LBL_OCUPACIONACTUAL' | translate }}
                    </label>
                    <p-dropdown disableTab id="idOcupacionActual" name="nomOcupacionActual"
                                [options]="listTipoOcupaciones"
                                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                                optionValue="value"
                                optionLabel="label"
                                formControlName="ocupacionActual"
                                (onChange)="calcularUltimaOcupacion(parametro.codigoParametro)"
                    ></p-dropdown>
                    <label class="falso-combo-texto" style="margin-top: 1rem; display: block;">
                      {{ fCoontrolsFCP[parametro.codigoParametro]?.value !== null &&
                         fCoontrolsFCP[parametro.codigoParametro]?.value !== undefined
                         ? fCoontrolsFCP[parametro.codigoParametro]?.value : '' }}
                    </label>
                  </div>

                  <!-- Endeudamiento Interno Socios (ENDINTSOC) -->
                  <div *ngIf="parametro.codigoParametro === parametrosPoliticas.ENDINTSOC">
                    <label for="porcentajeParticipación" style="font-size:14px !important">{{ 'POLITICAS.LBL_PORCENTAJEPARTICIPACION' | translate }}</label>
                    <input
                      style="text-align: right; margin-bottom: 1rem"
                      type="text"
                      pInputText
                      id="idPorcentajeParticipación"
                      name="nomPorcentajeParticipación"
                      autocomplete="off"
                      formControlName="porcentajeParticipacion"
                      appTexto
                      numero-decimal-reactive
                      [sinComa]="true"
                      [sinEspacio]="true"
                      [decimales]="6"
                      [entero]="3"
                      [maximo]="100"
                      [sinCaracteres]="true"
                      [sinPunto]="false"
                      [sinLetras]="true"
                      (blur)="validarEndeudamientoInternoSocios(parametro.codigoParametro)"
                    />
                    <label for="valorEndeudamiento" style="font-size:14px !important">{{ "POLITICAS.LBL_VALORENDEUDAMIEMTO" | translate }}</label>
                    <input
                      type="text"
                      pInputText
                      id="idValorEndeudamiento"
                      name="nomValorEndeudamiento"
                      autocomplete="new-password"
                      moneda-reactive
                      formControlName="valorEndeudamiento"
                      [maxlength]="17"
                      style="text-align: right; margin-bottom: 0.5rem"
                      (blur)="validarEndeudamientoInternoSocios(parametro.codigoParametro)"
                    />
                  </div>

                  <!-- Última Actividad Económica (ULTACTECO) -->
                  <div *ngIf="parametro.codigoParametro === parametrosPoliticas.ULTACTECO">
                    <label for="actividadEconomicaAnterior" style="font-size:14px !important">{{ 'POLITICAS.LBL_ACTIVIDADECONOMICAANTERIOR' | translate }}</label>
                    <p-dropdown disableTab id="idActividadEconomicaAnterior" name="nomActividadEconomicaAnterior"
                                [options]="listActividadEconomica"
                                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                                optionValue="value"
                                optionLabel="label"
                                filter="filter"
                                formControlName="actividadEconomicaAnterior"
                                (onChange)="calcularUltimaActividadEconomica(parametro.codigoParametro)"
                    ></p-dropdown>
                    <label for="actividadEconomicaActual" style="font-size:14px !important; margin-top: 10px; display: block;">
                      {{ 'POLITICAS.LBL_ACTIVIDADECONOMICAACTUAL' | translate }}
                    </label>
                    <p-dropdown disableTab id="idActividadEconomicaActual" name="nomActividadEconomicaActual"
                                [options]="listActividadEconomica"
                                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                                optionValue="value"
                                optionLabel="label"
                                filter="filter"
                                formControlName="actividadEconomicaActual"
                                (onChange)="calcularUltimaActividadEconomica(parametro.codigoParametro)"
                    ></p-dropdown>
                    <label class="falso-combo-texto" style="margin-top: 1rem; display: block;">
                      {{ fCoontrolsFCP[parametro.codigoParametro]?.value !== null &&
                         fCoontrolsFCP[parametro.codigoParametro]?.value !== undefined
                         ? fCoontrolsFCP[parametro.codigoParametro]?.value : '' }}
                    </label>
                  </div>

                  <!-- Garantía Idónea (GARIDON) -->
                  <div *ngIf="parametro.codigoParametro === parametrosPoliticas.GARIDON">
                    <label for="tipoGarantiaGaridon" style="font-size:14px !important">{{ 'POLITICAS.LBL_TIPOGARANTIA' | translate }}</label>
                    <p-dropdown disableTab id="idTipoGarantiaGaridon" name="nomTipoGarantiaGaridon"
                                [options]="listaTiposGarantias"
                                placeholder="{{ 'LBL_SELECCIONE' | translate }}"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate }}"
                                optionValue="value"
                                optionLabel="label"
                                filter="filter"
                                formControlName="tipoGarantiaGaridon"
                                (onChange)="calcularGarantiaIdonea(parametro.codigoParametro)"
                    ></p-dropdown>
                    <label class="falso-combo-texto" style="margin-top: 1rem; display: block;">
                      {{ fCoontrolsFCP[parametro.codigoParametro]?.value !== null &&
                         fCoontrolsFCP[parametro.codigoParametro]?.value !== undefined
                         ? fCoontrolsFCP[parametro.codigoParametro]?.value : '' }}
                    </label>
                  </div>

                  <!-- Nivel De Riesgo Empleador -->
                  <div *ngIf="parametro.codigoParametro === parametrosPoliticas.NIVELRIESGOEMPLEADOR">
                    <label for="nivelRiesgoEmpleador" style="font-size:14px !important">{{ "POLITICAS.LBL_NIVELRIESGOEMPLEADOR" | translate }}</label>
                    <input
                      type="text"
                      pInputText
                      id="nivelRiesgoEmpleador"
                      name="nivelRiesgoEmpleador"
                      autocomplete="false"
                      formControlName="nivelRiesgoEmpleador"
                      [maxlength]="2000"
                      (input)="calcularValorNivel(parametro.codigoParametro)"
                      style="margin-bottom: 0.5rem"
                    />
                    <label for="valorNivel" style="font-size:14px !important">{{ "POLITICAS.LBL_VALORNIVEL" | translate}}</label>
                    <input
                      type="text"
                      pInputText
                      id="id{{ parametro.codigoParametro }}"
                      name="nom{{ parametro.codigoParametro }}"
                      autocomplete="false"
                      formControlName="{{ parametro.codigoParametro }}"
                      [maxlength]="17"
                      disabled
                      style="text-align: right; margin-bottom: 1rem; border-bottom: 1px solid #bdbdbd;"
                    />
                  </div>

                  <!-- Campos parametro PORCOB - Porcentaje de Cobertura -->
                  <div *ngIf="parametro.codigoParametro === parametrosPoliticas.PORCENTAJECOBERTURA">
                    <label for="montoCobertura" style="font-size:14px !important">{{ "POLITICAS.LBL_MONTOCOBERTURA" | translate }}</label>
                    <input
                      type="text"
                      pInputText
                      id="montoCobertura"
                      name="montoCobertura"
                      autocomplete="new-password"
                      moneda-reactive
                      formControlName="montoCobertura"
                      [maxlength]="17"
                      (blur)="calcularPorcentajeCobertura(parametro.codigoParametro)"
                      style="text-align: right; margin-bottom: 0.5rem"
                    />
                    <label for="montoSolicitud" style="font-size:14px !important">{{ "POLITICAS.LBL_MONTOSOLICITUD" | translate}}</label>
                    <input
                      type="text"
                      pInputText
                      id="montoSolicitud"
                      name="montoSolicitud"
                      autocomplete="new-password"
                      moneda-reactive
                      formControlName="montoSolicitud"
                      [maxlength]="17"
                      (blur)="calcularPorcentajeCobertura(parametro.codigoParametro)"
                      style="text-align: right; margin-bottom: 1rem"
                    />
                    <label class="falso-combo-texto grid" style="text-align: right; margin-top: 20px" id="id{{ parametro.codigoParametro }}">
                        {{ porcentajeCobertura ? porcentajeCobertura + "%" : '' }}
                    </label>
                  </div>

                  <div *ngIf="parametro.codigoParametro === parametrosPoliticas.PORCENTAJESALDOCANCELADO">
                    <label for="saldoCapital" style="font-size:14px !important">{{ "POLITICAS.LBL_SALDOCAPITAL" | translate }}</label>
                    <input type="text" pInputText
                           id="saldoCapital"
                           name="nom{{parametro.codigoParametro}}"
                           autocomplete="new-password"
                           moneda-reactive
                           formControlName="{{parametro.codigoParametro}}"
                           [maxlength]="parametro.codigoParametro === parametrosPoliticas.PORCENTAJESALDOCANCELADO? 12: maxLength"
                           (blur)="calcular($event.target.value, true)"
                           style="text-align: right; margin-bottom: 0.5rem"
                    />
                    <label *ngIf="parametro.codigoParametro === parametrosPoliticas.PORCENTAJESALDOCANCELADO"
                           for="montoDesembolsado" style="font-size:14px !important">{{ "POLITICAS.LBL_MONTODESEMBOLSADO" | translate}}</label>
                    <input type="text" pInputText
                           id="montoDesembolsado"
                           name="nom{{parametro.codigoParametro}}"
                           autocomplete="new-password"
                           moneda-reactive
                           formControlName="{{parametro.codigoParametro}}"
                           [maxlength]="parametro.codigoParametro === parametrosPoliticas.PORCENTAJESALDOCANCELADO? 12: maxLength"
                           (blur)="calcular($event.target.value, false)"
                           style="text-align: right; margin-bottom: 1rem"
                    />
                    <label class="falso-combo-texto grid" style="text-align: right; margin-top: 20px" id="id{{ parametro.codigoParametro }}">
                        {{ porcetajeCancelado ? porcetajeCancelado + "%" : null }}
                    </label>
                  </div>

                  <!--                  MESES CUOTAS PAGADAS-->
                  <div *ngIf="parametro.codigoParametro === parametrosPoliticas.MESESCUOTASPAGADAS">
                    <label style="font-size:14px !important">{{ "POLITICAS.LBL_CUOTASPAGADAS" | translate}}</label>
                    <input type="text" pInputText (blur)="calcularMeses($event.target.value, true)"
                           formControlName="{{parametro.codigoParametro}}" appTexto [sinCaracteres]="true"
                           [sinEspacio]="true"
                           [sinLetras]="true"
                           [sinPunto]="true"
                           id="id{{ parametro.codigoParametro }}" name="nom{{parametro.codigoParametro}}"
                           autocomplete="new-password"
                           class="box-3-in-1" [maxlength]="parametro.codigoParametro === parametrosPoliticas.MESESCUOTASPAGADAS ? 3 : 9"
                    />
                    <label *ngIf="parametro.codigoParametro === parametrosPoliticas.MESESCUOTASPAGADAS"
                           style="font-size:14px !important">{{ "POLITICAS.LBL_FRECUENCIA" | translate}}</label>
                    <p-dropdown disableTab  id="id{{ parametro.codigoParametro }}" name="nom{{ parametro.codigoParametro }}"
                                [options]="listaFrecuenciaProducto" (onChange)="calcularMeses($event.value, false)"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                                emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                                optionValue="value"
                                optionLabel="label"
                    ></p-dropdown>
                    <label class="falso-combo-texto grid" style="text-align: right; margin-top: 20px" id="id{{ parametro.codigoParametro }}">
                      {{ mesesCuotas }}
                    </label>
                  </div>

                  <!-- Edad tercero -->
                  <div *ngIf="parametro.codigoParametro === parametrosPoliticas.EDADTERCERO">
                  <label>{{ "POLITICAS.LBL_EDAD" | translate}}</label>
                  <input type="text" pInputText (change)="calcularEdadTercero($event.target.value, parametro.codigoParametro )"
                          formControlName="edadTercero" appTexto [sinCaracteres]="true"
                          [sinEspacio]="true"
                          [sinLetras]="true"
                          [sinPunto]="true"
                          id="id{{ parametro.codigoParametro }}" name="nom{{parametro.codigoParametro}}"
                          autocomplete="new-password"
                          class="box-3-in-1" [maxlength]="parametro.codigoParametro === parametrosPoliticas.EDADTERCERO ? 3 : 9"
                  />
                  <label class="label-desembolso">{{ 'POLITICAS.LBL_MESES' | translate }}</label>
                  <label class="falso-combo-texto" style="text-align: right;">{{ edadTerceroMeses }}</label>
                  </div>

                   <!-- Cambio vinvulacion -->
                  <div *ngIf="parametro.codigoParametro === parametrosPoliticas.CAMBIODEVINCULACION">
                    <label style="font-size:14px !important">{{ "POLITICAS.LBL_VINCULACION" | translate}}</label>
                    <p-dropdown disableTab  id="id{{ parametro.codigoParametro }}" name="nom{{ parametro.codigoParametro }}"
                                [options]="listaTiposVinculacionesCruzada" (onChange)="cambioVinvulacion('vinculacion1', $event.value)"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter" [autoWidth]="false"
                    ></p-dropdown>
                    <label style="font-size:14px !important; margin-top: 10px; display: block;">{{ "POLITICAS.LBL_CAMBIOVINCULACION" | translate}}</label>
                    <p-dropdown disableTab  id="id{{ parametro.codigoParametro }}" name="nom{{ parametro.codigoParametro }}"
                                [options]="listaTiposVinculacionesCruzada" (onChange)="cambioVinvulacion('vinculacion2', $event.value)"
                                placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter" [autoWidth]="false"
                    ></p-dropdown>
                  </div>

                  <!-- Vinculación tiene Respaldo -->
                  <div *ngIf="parametro.codigoParametro === parametrosPoliticas.VINVULACIONRESPALDOS">
                  <input type="text" pInputText id="id{{ parametro.codigoParametro }}"
                        name="nom{{parametro.codigoParametro}}"
                        [negativo]="false"
                        autocomplete="new-password"
                        [minimo]="0"
                        moneda-reactive
                        (input)="actualizarMaxLength(parametro.codigoParametro)"
                        formControlName="vinculacionRespaldo"
                        [maxlength]="18"
                        style="text-align: right"
                  />
                  <div class="col-12" style="text-align: left;display: flex;align-items: center;">
                    <label style="margin: 0 5px;">{{'LBL_NO' | translate}}</label>
                    <p-inputSwitch (onChange)="validarVinculacionesRespaldos($event.checked)"></p-inputSwitch>
                    <label style="margin: 0 5px;">{{'LBL_SI' | translate}}</label>
                  </div>
                  </div>
                </p-fieldset>
              </div>
              <div style="text-align: left;display: flex;align-items: center; margin-top: 10px;"
                   *ngIf="
                      parametro.codigoParametro === parametrosPoliticas.QUANTOVALORMEDIO ||
                      parametro.codigoParametro === parametrosPoliticas.NOVEDADRETIRO ||
                      parametro.codigoParametro === parametrosPoliticas.TALANSOCIOSARLAFT ||
                      parametro.codigoParametro === parametrosPoliticas.TALANSOCIOSARLAFTJURIDICO ||
                      parametro.codigoParametro === parametrosPoliticas.TALANSOCIOSLISTASRES ||
                      parametro.codigoParametro === parametrosPoliticas.TALANSOCIOSNOTAINTERNA ||
                      parametro.codigoParametro === parametrosPoliticas.TALANLISTASNEGRASDOCUMENTOS ||
                      parametro.codigoParametro === parametrosPoliticas.TALANLISTASNEGRASTELEFONOS ||
                      parametro.codigoParametro === parametrosPoliticas.TALANLISTASNEGRASCORREOS">
                <label style="margin: 0 5px;">{{'POLITICAS.LBL_INACTIVO' | translate}}</label>
                <p-inputSwitch
                  id="id{{ parametro.codigoParametro }}"
                  name="nom{{parametro.codigoParametro}}"
                  formControlName="{{parametro.codigoParametro}}"></p-inputSwitch>
                <label style="margin: 0 5px;">{{'POLITICAS.LBL_ACTIVO' | translate}}</label>
              </div>
              <div style="text-align: left;display: flex;align-items: center; padding-top: 10px" *ngIf="parametro.codigoParametro === parametrosPoliticas.TERCEROASEGURABLE">
                <label style="margin: 0 5px;">{{'POLITICAS.LBL_INHABILITADO' | translate}}</label>
                <p-inputSwitch
                  id="id{{ parametro.codigoParametro }}"
                  name="nom{{parametro.codigoParametro}}"
                  formControlName="{{parametro.codigoParametro}}"></p-inputSwitch>
                <label style="margin: 0 5px;">{{'POLITICAS.LBL_HABILITADO' | translate}}</label>
              </div>
              <div style="text-align: left;display: flex;align-items: center; padding-top: 10px" *ngIf="parametro.codigoParametro === parametrosPoliticas.FIRPAG">
                <label style="margin: 0 5px;">{{'LBL_NO' | translate}}</label>
                <p-inputSwitch
                  id="id{{ parametro.codigoParametro }}"
                  name="nom{{parametro.codigoParametro}}"
                  formControlName="{{parametro.codigoParametro}}"></p-inputSwitch>
                <label style="margin: 0 5px;">{{'LBL_SI' | translate}}</label>
              </div>
              <p-calendar
                *ngIf="
                  parametro.codigoParametro === parametrosPoliticas.DESEMBOLSOFINANANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.DESEMBOLSOCOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.DESEMBOLSOREAL ||
                  parametro.codigoParametro === parametrosPoliticas.FECHASOLICITUD ||
                  parametro.codigoParametro === parametrosPoliticas.COBROJURIDICOSECTORREAL ||
                  parametro.codigoParametro === parametrosPoliticas.COBROJURIDICOCOOPERATIVO ||
                  parametro.codigoParametro === parametrosPoliticas.COBROJURIDICOFINANCIERO ||
                  parametro.codigoParametro === parametrosPoliticas.FECHACIERRECOBROJURIDICO ||
                  parametro.codigoParametro === parametrosPoliticas.DESEMBOLSOFINANANCIEROPASIVOMANUAL ||
                  parametro.codigoParametro === parametrosPoliticas.DESEMBOLSOCOOPERATIVOPASIVOMANUAL ||
                  parametro.codigoParametro === parametrosPoliticas.DESEMBOLSOREALPASIVOMANUAL
                "
                id="id{{ parametro.codigoParametro }}"
                [showButtonBar]="false"
                name="nom{{ parametro.codigoParametro }}"
                [showIcon]="true"
                [showTime]="false"
                [monthNavigator]="true"
                [yearNavigator]="true"
                yearRange="{{ calPropiedades.rango }}"
                [locale]="calPropiedades.informacion"
                readonlyInput="true"
                formControlName="{{ parametro.codigoParametro }}"
                dataType="date"
                dateFormat="yy'-'mm'-'dd"
              >
              </p-calendar>
              <p-calendar
                *ngIf="
                  parametro.codigoParametro === parametrosPoliticas.FECHAULTIMODESEMBOLSOCREZCAMOS ||
                  parametro.codigoParametro === parametrosPoliticas.FECHAULTIMOCIERRECREDITOCREZCAMOS ||
                  parametro.codigoParametro === parametrosPoliticas.FECHANACIMIENTOTER ||
                  parametro.codigoParametro === parametrosPoliticas.FECHAEXPEDICIONTER ||
                  parametro.codigoParametro === parametrosPoliticas.FECEXPTU
                "
                id="id{{ parametro.codigoParametro }}"
                [showButtonBar]="false"
                name="nom{{ parametro.codigoParametro }}"
                [showIcon]="true"
                [showTime]="false"
                [monthNavigator]="true"
                [yearNavigator]="true"
                yearRange="{{ calPropiedades.rango }}"
                [locale]="calPropiedades.informacion"
                [minDate]="parametro.codigoParametro === parametrosPoliticas.FECEXPTU ? null : minFechaDocumento"
                [maxDate]="fechaActual"
                readonlyInput="true"
                formControlName="{{ parametro.codigoParametro }}"
                dataType="date"
                dateFormat="yy'-'mm'-'dd"
              >
              </p-calendar>
              <p-calendar
                *ngIf="parametro.codigoParametro === parametrosPoliticas.FECHAACT"
                id="id{{ parametro.codigoParametro }}"
                name="nom{{ parametro.codigoParametro }}"
                [showIcon]="true"
                [showTime]="false"
                [monthNavigator]="true"
                [yearNavigator]="true"
                yearRange="{{ calPropiedades.rango }}"
                [locale]="calPropiedades.informacion"
                [disableControl]="true"
                [readonlyInput]="true"
                [showButtonBar]="false"
                formControlName="{{ parametro.codigoParametro }}"
                dataType="date"
                dateFormat="yy'-'mm'-'dd">
              </p-calendar>
              <div
                class="p-message p-messages-error p-corner-all"
                *ngIf="
                  submittedModalComprobarPolitica &&
                  fCoontrolsFCP[parametro.codigoParametro].invalid &&
                    parametro.codigoParametro !== parametrosPoliticas.VALIDACIONFIRMASCONYUGES &&
                    parametro.codigoParametro !== parametrosPoliticas.MESESDESEMBOLSO &&
                    parametro.codigoParametro !== parametrosPoliticas.VENTACRUZADA &&
                    parametro.codigoParametro !== parametrosPoliticas.TERCEROASEGURABLE &&
                    parametro.codigoParametro !== parametrosPoliticas.DIA
                "
              >
                {{ parametro.parametro | titlecase }}
                {{ "LBL_REQUERIDO" | translate }}
              </div>
              <input
                *ngIf="parametro.codigoParametro === parametrosPoliticas.PUNTAJESCORE"
                type="text"
                pInputText
                id="id{{ parametro.codigoParametro }}"
                name="nom{{ parametro.codigoParametro }}"
                autocomplete="off"
                formControlName="{{ parametro.codigoParametro }}"
                appTexto
                numero-entero-reactive
                [negativo]="true"
                (input)="actualizarMaxLength(parametro.codigoParametro)"
                [maxlength]="maxLength"
              />
            </div>
            <div class="div-form" style="display: flex; flex-wrap: nowrap; margin-top: 2px !important;" *ngIf="parametro.codigoParametro === parametrosPoliticas.CONNOM">
              <div style="margin-right: 2px">
                <label style="font-size:12px !important; display: block;">* {{ "POLITICAS.LBL_DATOSSOLICITUD" | translate}}</label>
                <input
                  style="height: 30px;"
                  type="text"
                  pInputText
                  id="id{{ parametro.codigoParametro }}solicitud"
                  name="nom{{ parametro.codigoParametro }}solicitud"
                  autocomplete="off"
                  formControlName="datosSolicitud"
                  appTexto
                  [sinCaracteres]="true"
                  [sinComa]="true"
                  [sinEspacio]="true" [sinPunto]="true"
                  [sinNumeros]="true"
                  [maxlength]="60"
                  (input)="comprobarNombre()"
                  [value]="formularioComprobarPolitica.get('datosSolicitud')?.value | uppercase"
                />
                <div
                  class="p-message p-messages-error p-corner-all"
                  *ngIf="submittedModalComprobarPolitica && fCoontrolsFCP['datosSolicitud'].invalid"
                >
                  {{ "POLITICAS.LBL_DATOSSOLICITUD" | translate }}
                  {{ "LBL_REQUERIDO" | translate }}
                </div>
              </div>
              <div>
                <label style="font-size:12px !important; display: block;">* {{ "POLITICAS.LBL_DATOSCONSULTA" | translate}}</label>
                <input
                  style="height: 30px;"
                  type="text"
                  pInputText
                  id="id{{ parametro.codigoParametro }}Consulta"
                  name="nom{{ parametro.codigoParametro }}Consulta"
                  autocomplete="off"
                  formControlName="datosConsultas"
                  appTexto
                  [sinCaracteres]="true"
                  [sinComa]="true"
                  [sinEspacio]="true" [sinPunto]="true"
                  [sinNumeros]="true"
                  [maxlength]="60"
                  (input)="comprobarNombre()"
                  [value]="formularioComprobarPolitica.get('datosConsultas')?.value | uppercase"
                />
                <div
                  class="p-message p-messages-error p-corner-all"
                  *ngIf="submittedModalComprobarPolitica && fCoontrolsFCP['datosConsultas'].invalid"
                >
                  {{ "POLITICAS.LBL_DATOSCONSULTA" | translate }}
                  {{ "LBL_REQUERIDO" | translate }}
                </div>
              </div>

            </div>
          </div>
          </ng-container>
          <div class="col-12 md:col-6 lg:col-6" *ngIf="aplica">
            <label>{{'POLITICAS.LBL_PERFILRIESGO' | translate }}</label>
            <p-dropdown disableTab  id="" name="nomIdPerfilRiesgo"
                        [options]="listPerfilesRiesgos"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter"
                         formControlName="idPerfilRiesgo"
                        emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        optionValue="value"
                        optionLabel="label"
            ></p-dropdown>
          </div>
        </div>
        <!-- BOTON COMPRAR POLITICA -->
        <div class="form-group col-12 text-center">
          <button
            *ngIf="!comprobandoPolitica"
            icon="fa fa-check-square"
            label="{{ 'POLITICAS.LBL_PROBARPOLITICA' | translate }}"
            type="submit"
            pButton
          ></button>
          <div *ngIf="comprobandoPolitica">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br/>
            <span>{{ "POLITICAS.LBL_COMPROBANDO" | translate }}</span>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="grid form-footer-buttons col-12 d-flex justify-content-center">
    <div *ngIf="cumplePolitica !== null">
      <div
        class="form-group col-12 text-center"
        *ngIf="cumplePolitica.estado === true"
      >
        <label class="text-center">{{
          "POLITICAS.LBL_CLIENTECUMPLEPOLITICA" | translate
          }}</label>
        <i class="fa fa-check-circle" style="color: green"></i>
      </div>
      <div
        class="form-group col-12 text-center"
        *ngIf="cumplePolitica.estado === false"
      >
        <label class="text-center">{{
          "POLITICAS.LBL_CLIENTENOCUMPLEPOLITICA" | translate
          }}</label>
        <i class="fa fa-close" style="color: red"></i>
      </div>
      <div
        class="form-group col-12 text-center"
        *ngIf="cumplePolitica.mensaje"
      >
        <label class="text-center">{{ cumplePolitica.mensaje }}</label>
        <i class="fa fa-close" style="color: red"></i>
      </div>
    </div>
    <div class="form-group col-12 text-center">
      <!-- BOTON CERRAR -->
      <a (click)="cerrarModalComprobarPolitica()" class="cancelar">{{
        "BTN_CANCELAR" | translate
        }}</a>
    </div>
  </div>
</p-dialog>
<p-confirmDialog key="eliminar" #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
